import React, { useState, useEffect } from "react";
import { Contract } from "@ethersproject/contracts";
import { useForm } from "react-hook-form";
import { getDefaultProvider, JsonRpcProvider, Web3Provider } from "@ethersproject/providers";
import { useQuery } from "@apollo/react-hooks";

import { Body, Button, Header, Image, Logo, ClickLink, Input } from "../components";

import mute from "../mute240.png";
import unmute from "../sound240.png";
import soundtrack from "../elements.mp3";
import molecs from "../molecs.gif";
import Sound from "react-sound";

import { Container, Row, Col} from 'react-bootstrap';


import useWeb3Modal from "../hooks/useWeb3Modal";
import Web3 from "web3";

import { addresses, abis } from "../contracts/index.js";
//import GET_TRANSFERS from "../graphql/subgraph";

/*
import p5 from "p5";
import Sketch from "react-p5";
import { setup, draw } from "../sketch.js"
*/
// parse xml
import XMLParser from 'react-xml-parser';



/////////////////////////////////////////////////////////////////////
// SUPPORT FUNCTIONS
/////////////////////////////////////////////////////////////////////

const marginTop={"margin-top":"15px"};
function WalletButton({ provider, loadWeb3Modal, logoutOfWeb3Modal }) {
  return (
    <button
      type="button" class="nes-btn" style={marginTop}
      onClick={() => {
        if (!provider) {
          loadWeb3Modal();
        } else {
          logoutOfWeb3Modal();
        }
      }}
    >
      {!provider ? "Connect Wallet" : "Disconnect Wallet"}
    </button>
  );
}


async function mintMolecule(formula, key, name, scriptId, numOfElements) {
  //const defaultProvider = getDefaultProvider();


  // A Web3Provider wraps a standard Web3 provider, which is
  // what Metamask injects as window.ethereum into each page
  //const provider = new ethers.providers.Web3Provider(window.ethereum)
  //const url = "http://localhost:7545"
  //const provider = new JsonRpcProvider(url);
  // The Metamask plugin also allows signing transactions to
  // send ether and pay to change state within the blockchain.
  // For this, you need the account signer...
  const provider = new Web3Provider(window.ethereum);
  const signer = await provider.getSigner();
  const userAddress = await signer.getAddress();
  const moleculeContract = new Contract(addresses.chemscriptsAddress, abis.moleculesynthesizer, provider);
  const moleculeWithSigner = moleculeContract.connect(signer);
  const price = await moleculeContract.getPrice(scriptId);
  //const prov = await defaultProvider.getBalance("0x5280Fa6183CC5DbC678e382Ebed6653AEc39077D");
  console.log("ADDRESS: " + userAddress);
  console.log("PRICE: " + price);
  const mint = await moleculeWithSigner.mintMolecule(formula, key, name, scriptId, numOfElements, { value : price.toString() });
}

// make it work ??
async function getSupply(_scriptId) {

  const provider = new Web3Provider(window.ethereum);
  //const signer = await provider.getSigner();
  //const userAddress = await signer.getAddress();
  const moleculeContract = new Contract(addresses.chemscriptsAddress, abis.moleculesynthesizer, provider);
  //const moleculeWithSigner = moleculeContract.connect(signer);
  const script = await moleculeContract.scripts(_scriptId);
  const currentSupply = await script["currentSupply"];
  const totalSupply = await script["totalSupply"];
  //const prov = await defaultProvider.getBalance("0x5280Fa6183CC5DbC678e382Ebed6653AEc39077D");
  console.log("SUPPLY: " + currentSupply.toString());
  //const mint = await moleculeWithSigner.mintMolecule(userAddress, { value : price.toString() });
  return(currentSupply.toString() + " / " + totalSupply.toString());
}

async function getPrice(_scriptId) {

  const provider = new Web3Provider(window.ethereum);
  //const signer = await provider.getSigner();
  //const userAddress = await signer.getAddress();
  const moleculeContract = new Contract(addresses.chemscriptsAddress, abis.moleculesynthesizer, provider);
  //const moleculeWithSigner = moleculeContract.connect(signer);
  const price = await moleculeContract.getPrice(0);
  const web3 = new Web3(provider);
  const priceInEth = web3.utils.fromWei(price.toString(), 'ether');
  return(priceInEth);
}

//Script data
// https://reactjs.org/docs/hooks-state.html
function ScriptInfo() {
  // Declare a new state variable, which we'll call "count"
  const [supply, setSupply] = useState("Connect Wallet...");
  if(window.ethereum) {
    getSupply(0).then(result => {
      setSupply(result)
    }).catch(error => {
      setSupply("Wrong network")
    });
  }

  const [price, setPrice] = useState("Connect Wallet...");
  if(window.ethereum) {
    getPrice(0).then(result => {
      setPrice(result)
    }).catch(error => {
      setPrice("Wrong network")
    });;
  }

  return (
    <div>
      <p>Minted: {supply} </p>
      <p>Price: {price} ETH</p>
    </div>
  );
}

async function checkKey(key) {

  const provider = new Web3Provider(window.ethereum);
  //const signer = await provider.getSigner();
  //const userAddress = await signer.getAddress();
  const moleculeContract = new Contract(addresses.chemscriptsAddress, abis.moleculesynthesizer, provider);
  //const moleculeWithSigner = moleculeContract.connect(signer);
  const mol = await moleculeContract.keys(key);
  if (mol > 0) {
    return("Already minted");
  } else {
    return("Available");
  }
}

// sound position
let pos;




/////////////////////////////////////////////////////////////////////
// APP CODE
/////////////////////////////////////////////////////////////////////


const PublicMint = () => {
  //const { loading, error, data } = useQuery(GET_TRANSFERS);
  const [provider, loadWeb3Modal, logoutOfWeb3Modal] = useWeb3Modal();

  // form handling
  const {register, handleSubmit, errors} = useForm();

  // state updating
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [molecName, setMolecName] = useState("none");
  const [molecFormula, setMolecFormula] = useState("none");
  const [molecKey, setMolecKey] = useState("none");
  const [mintable, setMintable] = useState("Available");

  const onSubmit = (data) => {
    Api(data.name);
  }


  function MoleculeComponent() {
    if (error) {
      return (
        <div class="nes-container with-title is-rounded">
          <p class="title">Molecule Selected</p>
          Name: {molecName}
          <br/>
          <p>Formula: {molecFormula}
          <br/>
          Key: {molecKey}
          <br/>
          <span class="nes-text is-error">Error: {error}</span>
          </p>

        </div>
      );
    } else if (!isLoaded) {
      return (
        <div class="nes-container with-title is-rounded">
          <p class="title">Molecule Selected</p>
          Name: {molecName}
          <br/>
          <p>Formula: {molecFormula}
          <br/>
          Key: {molecKey}
          </p>
        </div>
      );
    } else {
      //let previewURL = "http://localhost:3000/sketch.html?" + items.getElementsByTagName('item')[0].value;
      //<a href={previewURL}>Preview</a>
      checkKey(molecKey.slice(9,molecKey.length)).then(result => {
        setMintable(result);
      });
      return (
        <div class="nes-container with-title is-rounded">
          <p class="title">Molecule Selected</p>
          Name: {molecName}
          <br/>
          <p>Formula: {molecFormula}
          <br/>
          Key: {molecKey}
          <br/>
          Status: <span class={isLoaded && mintable=="Available"? "nes-text is-success" : "nes-text is-error"}>{mintable}</span>
          </p>

          <br/>
        </div>
      );
    }
  }

  function Api(chemName) {

    const url =  'https://cactus.nci.nih.gov/chemical/structure/';
    const dataFormat = '/InChI/xml/';
    const keyFormat = '/InChIKey/xml';
    setError(false);
    fetch(url + chemName + keyFormat)
        .then(res => res.text())
        .then(data => {
          var xml = new XMLParser().parseFromString(data);
          if (xml.getElementsByTagName('item').length > 0) {
            setMolecKey(xml.getElementsByTagName('item')[0].value);
          } else {
            setError("No molecule found with that name.");
            setMolecName("none");
            setMolecKey("none");
            setMolecFormula("none");
            setIsLoaded(true);
          }
      },
      (error) => {
        setMolecName("none");
        setMolecKey("none");
        setMolecFormula("none");
        setError(error);
        setIsLoaded(true);
        })

    fetch(url + chemName + dataFormat)
        .then(res => res.text())
        .then(data => {
            var xml = new XMLParser().parseFromString(data);
            console.log(xml)
            if (xml.getElementsByTagName('item').length > 0) {
              setItems(xml);
              setMolecFormula(xml.getElementsByTagName('item')[0].value);
              setMolecName(xml.children[0].attributes['notation']);
              setIsLoaded(true);
            } else {
              setError("No molecule found with that name.");
              setIsLoaded(true);
            }
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )

    return (
        <div></div>
    )
  }

  //background music
  const [isPlaying, setIsPlaying] = useState(false);
  let duration;
  function pauseMusic(data){
    pos = data['position'];
    duration = data['duration'];
  }
  function onPlaying(data) {
    pos =data['position'];
  }
  function onFinishedPlaying() {
    setIsPlaying(false);
    pos = 0;
    setIsPlaying(true);
  }

  function PlaySound (
    handleSongLoading,
    handleSongPlaying,
    handleSongFinishedPlaying
  ) {
    return (
      <div>
        <Sound
          url={soundtrack}
          playStatus={
            isPlaying ? Sound.status.PLAYING : Sound.status.PAUSED
          }
          playFromPosition={pos + 200}
          onPause={pauseMusic}
          onStop={pauseMusic}
          //onLoading={handleSongLoading}
          onPlaying={onPlaying}
          onFinishedPlaying={onFinishedPlaying}
          loop={false}
        />
      </div>
    );
  }


  const [mintDialog, setMintDialog] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const mintButton = (data) => {
    // add some preprocessing
    // edit formula
    // edit key
    // calculate number of elements
    setDisabled(true);
    setMintDialog(
      <span class="nes-text is-success">Mint is being processed, wait for wallet popup</span>
    );
    //prepare molecule info to match the required minting format
    const molecKeyShort = molecKey.slice(9,molecKey.length);
    let molecFormulaShort;
    let slashCounter=0;
    let numOfElements=0;
    for (let k = 6; k <= molecFormula.length; k++) {
      if (/^[A-Z]*$/.test(molecFormula[k])) {
        numOfElements++;
      }
      if (molecFormula[k] == "/") {
        slashCounter++;
      }
      if (slashCounter > 1 || k == molecFormula.length) {
        molecFormulaShort = molecFormula.slice(6,k+2);
        if (numOfElements == 1) {
          molecFormulaShort = molecFormulaShort + "/x";
        }
        break;
      }
    }


    mintMolecule(molecFormulaShort, molecKeyShort, molecName, 0, numOfElements).then(result => {
      setMintDialog(
        <span class="nes-text is-success">Mint transaction submitted - check your molecule on OpenSea or mint some more!</span>
      );
      setDisabled(false);
    }).catch(error => {
      console.info(error)
      //wrong network
      if (error["message"] == 'call revert exception (method="getPrice(uint256)", errorArgs=null, errorName=null, errorSignature=null, reason=null, code=CALL_EXCEPTION, version=abi/5.4.0)') {
        setMintDialog(
          <span class="nes-text is-error">Wrong network, make sure to mint on Ethereum Mainnet</span>
        )
        setDisabled(false);
      // other error like transaction in MM rejected
      } else {
        setMintDialog(
          <span class="nes-text is-error">{error["message"]}</span>
        )
        setDisabled(false);
      }
    });
  }

  // RANDOM MOLEC MINT
  const randomMint = (data) => {
    setDisabled(true);
    setMintDialog(
      <span class="nes-text is-success">Mint is being processed, wait for wallet popup</span>
    );
    fetch("https://meta-whitelist-api.herokuapp.com/molecule")
      .then(res => res.text())
        .then(data => {
          const molec = JSON.parse(data)['body'];

          let molecFormulaShort;
          let slashCounter=0;
          let numOfElements=0;
          let molecFormula = molec['formula'];
          for (let k = 0; k <= molecFormula.length; k++) {
            if (/^[A-Z]*$/.test(molecFormula[k])) {
              numOfElements++;
            }
            if (molecFormula[k] == "/") {
              slashCounter++;
            }
            if (slashCounter > 1 || k == molecFormula.length) {
              molecFormulaShort = molecFormula.slice(6,k+2);
              if (numOfElements == 1) {
                molecFormulaShort = molecFormulaShort + "/x";
              }
              break;
            }
          }

          mintMolecule(molec['formula'], molec['key'], molec['name'], 0, numOfElements).then(result => {
            setMintDialog(
              <span class="nes-text is-success">Mint transaction submitted - check your molecule on OpenSea or mint some more!</span>
            );
            setDisabled(false);
          }).catch(error => {
            console.info(error)
            //wrong network
            if (error["message"] == 'call revert exception (method="getPrice(uint256)", errorArgs=null, errorName=null, errorSignature=null, reason=null, code=CALL_EXCEPTION, version=abi/5.4.0)') {
              setMintDialog(
                <span class="nes-text is-error">Wrong network, make sure to mint on Ethereum Mainnet</span>
              )
              setDisabled(false);
            // other error like transaction in MM rejected
            } else {
              setMintDialog(
                <span class="nes-text is-error">{error["message"]}</span>
              )
              setDisabled(false);
            }
          });
    })


  }


  const styleMargin={"margin-bottom": "25px"};
  const pixelated={"image-rendering": "pixelated"}
  const transparent={"background-color" : "transparent", "border" : "none", "margin-left": "20px", "margin-right": "20px", "margin-top":"10px"};
  const etherscanLink="https://etherscan.io/address/" + addresses.chemscriptsAddress;
  const openseaLink="https://opensea.io/collection/chemscripts";

  return (
    <div>
      <Header>
        <a style={{"margin-right": "40px", "margin-top": "15px", "color":"black"}} target="_blank" href="https://elementblocks.org/molecules.html">About</a>
        <WalletButton provider={provider} loadWeb3Modal={loadWeb3Modal} logoutOfWeb3Modal={logoutOfWeb3Modal} />
        <button style={transparent} onClick={() => setIsPlaying(!isPlaying)}><img src={isPlaying ? unmute : mute} width="60"/> </button>
      </Header>
      <Body>
        <PlaySound/>
        <Container>
          <Row>
            <p/>
            <p/>
            <p/>
          </Row>
          <Row>
            <Col>
              <div class="nes-container with-title is-rounded">
                <p class="title">The Artwork</p>
                <Image src={molecs} alt="metalab-logo" />
              </div>
            </Col>
            <Col>
              <h2>Higgs Strings </h2>
              <p class="nes-badge">
                <span class="is-warning">by Aaru</span>
              </p>
              <br/>
              <br/>
              <ScriptInfo/>

              <p>Every molecule can only be minted once per script. </p>

              <br/>
              <form onSubmit={handleSubmit(randomMint)}>
                <button class={!disabled? "nes-btn is-primary" : "nes-btn is-disabled"} type="submit" value="Mint">Mint Random Molecule</button>
              </form>
              <br/>
              {mintDialog}


            </Col>
          </Row>
          <br/>

          <br/>
          <br/>
          <Row>
            <Col>
            <br/>
            <form onSubmit={handleSubmit(onSubmit)}>
              <label for="molecule_field">Or search a custom molecule here:</label>
              <input style={styleMargin} class="nes-input" id="molecule_field" type="text" placeholder="e.g. Water" {...register("name")}/>
              <button class="nes-btn" type="submit" value="Search">Search..</button>
            </form>
            <br/>
            <br/>
              <MoleculeComponent/>
              <br/>
              <form onSubmit={handleSubmit(mintButton)} style={styleMargin}>
                <button type="submit" value="MINT" class={!disabled && isLoaded && mintable=="Available" && !error? "nes-btn is-primary" : "nes-btn is-disabled"}>Mint Molecule</button>
              </form>
              <br/>
              {mintDialog}
              <br/>
              <br/>
            </Col>
          </Row>
          <Row>
            <Col>
              <span class="nes-text">Each molecule's chemical metadata and the script that generates the artwork are fully onchain.</span>
              <br/>
              <br/>
              <span class="nes-text is-disabled">Half of the minting proceeds flow directly to ElementBlock holders.</span>
              <br/>
              <br/>
              <span class="nes-text is-disabled">Music: Elements by Scott Semanski</span>
              <br/>
              <br/>
              <span class="nes-text is-disabled">Experimental software - use at your own risk.</span>
              <br/>
              <br/>
              <span class="nes-text is-disabled">View ChemScripts on: </span>
              <a href={etherscanLink} target="_blank" >EtherScan</a>
              <span class="nes-text is-disabled"> / </span>
              <a href={openseaLink} target="_blank" >OpenSea</a>
              <span class="nes-text is-disabled"> / </span>
              <a href="https://twitter.com/ChemScripts/" target="_blank" >Twitter</a>
              <br/>
              <br/>
              <span class="nes-text is-disabled">View ElementBlocks on: </span>
              <a href="https://opensea.io/collection/elementblocks" target="_blank" >OpenSea</a>
              <span class="nes-text is-disabled"> / </span>
              <a href="https://twitter.com/ElementBlocks" target="_blank" >Twitter</a>
              <p/>
            </Col>
          </Row>
        </Container>




      </Body>
    </div>
  );
}


export default PublicMint;
